import { combineReducers } from 'redux';
import { organizations } from './reducers/organizations';
import { locations } from './reducers/locations';
import { auth } from './reducers/auth';
import { users } from './reducers/users';
import { transactions } from './reducers/transactions';
import { balance } from './reducers/balance';
import { settings } from './reducers/settings';
import { information } from './reducers/information';
import { appRoutes } from './routes';
import { initAuth } from './services/auth';
import { departments } from "./reducers/departments";
import { passwordReset } from "~/apps/shared/reducers/passwordReset";

export const initReducers = () => {
  return {
    shared: combineReducers({
      auth,
      organizations,
      locations,
      users,
      transactions,
      balance,
      settings,
      information,
      departments,
      passwordReset,
    })
  };
};

export const initRoutes = () => {
  return appRoutes;
};

export const initApp = (store) => {
  initAuth(store);
};
